export enum SignUpActionMessages {
  SUCCESS = "SUCCESS",
  USERNAME_EXISTS = "User already exists.",
  UNKNOWN_ERROR = "Something went wrong during sign up.",
}

export enum SignInActionMessages {
  SUCCESS = "SUCCESS",
  USER_NOT_FOUND = "User not found.",
  USER_NOT_CONFIRMED = "User not confirmed.",
  USER_NOT_ACTIVATED = "User account is pending activation.",
  INVALID_PASSWORD = "Invalid password.",
  UNKNOWN_ERROR = "Something went wrong during sign in.",
}

export enum VerifyAccountActionMessages {
  SUCCESS = "SUCCESS",
  USERNAME_NOT_FOUND = "User not found.",
  INVALID_VERIFICATION_CODE = "Invalid verification code.",
  UNKNOWN_ERROR = "Something went wrong during verification.",
}

export enum ResendCodeActionMessages {
  SUCCESS = "SUCCESS",
  USERNAME_NOT_FOUND = "User not found.",
  UNKNOWN_ERROR = "Something went wrong when resending verification code.",
}

export enum ForgotPasswordActionMessages {
  SUCCESS = "SUCCESS",
  USERNAME_NOT_FOUND = "User not found.",
  LIMIT_EXCEEDED = "Limit exceeded.",
  UNKNOWN_ERROR = "Something went wrong during password reset.",
}

export enum SetPasswordActionMessages {
  SUCCESS = "SUCCESS",
  USERNAME_NOT_FOUND = "User not found.",
  INVALID_VERIFICATION_CODE = "Invalid verification code.",
  UNKNOWN_ERROR = "Something went wrong during password reset.",
}

export enum CaseStatus {
  OPEN = "OPEN",
  CLOSED = "CLOSED",
  ARCHIVED = "ARCHIVED",
}

/**
 * Restated here because the API publishes `analysisStatus` as a String rather
 * than an enum, so codegen produces nothing to import for it.
 *
 * `DocumentFailureStage` is deliberately *not* here: that one the API does
 * publish as an enum, so it comes from `@/src/graphql/generatedCode/graphql`
 * and cannot drift from the schema. Declaring a second copy of it made two
 * nominally different types with the same name, which TypeScript refuses to
 * assign between.
 */
export enum DocumentAnalysisStatus {
  PENDING = "PENDING",
  UPLOADED = "UPLOADED",
  INGESTING = "INGESTING",
  EXTRACTING = "EXTRACTING",
  READY = "READY",
  ANALYZING = "ANALYZING",
  COMPLETE = "COMPLETE",
  FAILED = "FAILED",
  REJECTED = "REJECTED",
  UNSUPPORTED = "UNSUPPORTED",
}

export enum DocumentFailureStage {
  PARSING = "PARSING",
  ANALYSIS = "ANALYSIS",
}
